import axios from 'axios';
import apiConfig from "../apiconfigs/apiConfig";
import qs from 'qs';


function  commonApiFunction(params,  callback, callbackError) {
   
   
    axios.post(apiConfig.api_url, qs.stringify(params), { timeout: 30000})
        .then((response) => {
           
            callback(response);

        }).catch((error) => {
           
            callbackError(error);

        })
}

export function  commonloginApiFunction(methodname,params,  callback, callbackError) {
   
    axios.post(apiConfig.api_url+methodname, qs.stringify(params), { timeout: 30000})
        .then((response) => {
           
            callback(response);

        }).catch((error) => {
           
            callbackError(error);

        })
}

export function  commonpostApiFunction(methodname,params, callback, callbackError) {
   
    axios.post(
        apiConfig.api_url+methodname, qs.stringify(params), 
        {headers: {
            'Authorization': `Bearer ${params.token}`,
        }}
        )
        .then((response) => {
            
            callback(response);

        }).catch((error) => {
            
            callbackError(error);

        })
}

export function  commongetApiFunction(methodname,params,  callback, callbackError) {
   
    axios.get(apiConfig.api_url+methodname, qs.stringify(params), { timeout: 30000})
        .then((response) => {
            
            callback(response);

        }).catch((error) => {
            
            callbackError(error);

        })
}

export function  commonputApiFunction(methodname,params,  callback, callbackError) {
   
    axios.put(apiConfig.api_url+methodname, qs.stringify(params), { timeout: 30000})
        .then((response) => {
           
            callback(response);

        }).catch((error) => {
            
            callbackError(error);

        })
}

export function  commonslimApiFunction(methodname,params,  callback, callbackError) {
   
    axios.post(apiConfig.api_url+methodname, qs.stringify(params), { timeout: 30000})
        .then((response) => {
            
            callback(response);

        }).catch((error) => {
            
            callbackError(error);

        })
}

export function uploadImageFileFunctionRest(methodname, formData, callback, token) {

   
    axios.post(apiConfig.api_url+methodname, formData, {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`,
      }
    }).then((response) => {
       
       callback(response);
    }).catch(error => {
      
    })
  
  }

// export function  commongetApiFunction(params,  callback, callbackError) {
// FreezeUI({ text: "Loading...", selector: 'body' });//    
//  axios.get(apiConfig.api_url, qs.stringify(params), { timeout: 30000})
//         .then((response) => {
    // UnfreezeUI()
//             callback(response);

//         }).catch((error) => {
    // UnfreezeUI()
//             //console.log(error)

//             callbackError(error);

//         })
// }


// module.exports={
//     commonApiFunction: commonApiFunction,
// }

export function extraParamApiFunctionRest(methodname, params, callback, variable) {
    
    axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
      {
        headers: {
          'Authorization': `Bearer ${params.token}`,
        }
      }
    )
      .then((response) => {
       
        callback(response, variable);
      }).catch((error) => {
       
      })
  }
  
  export function MultiParamReturnApiFunctionRest(methodname, params, callback, variable1, variable2) {
    
    axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
      {
        headers: {
          'Authorization': `Bearer ${params.token}`,
        }
      }
    )
      .then((response) => {
       
        callback(response, variable1, variable2);
      }).catch((error) => {
       
      })
  }
 export default commonApiFunction

// export commongetApiFunction